import { colors } from '../../colors';
var footer = {
  textColor: colors.graphite,
  primaryColor: colors.graphite,
  bgColor: colors.pearl,
  textHoverColor: colors.graphite,
  textAddressColor: colors.graphite,
  textOperationHoursColor: colors.graphite,
  textPrimaryLinksColor: colors.petsuitesPurple,
  textPrimaryLinksHoverColor: colors.petsuitesPurple,
  seperatorColor: colors.overcast,
  primaryLinksFontWeight: 'normal',
  tertiaryLinkLetterSpacing: '0.13px',
  textColorDark: colors.graphite,
  textColorLight: colors.white
};
export default footer;